module.exports = "{{{text}}}";